import {getDomestic, getRange, getTailNumber} from "../store/FlightStore";

export default class CacheManager {

    stateName = null;

    constructor(stateName: null) {
        this.stateName = stateName;
    }

    setCache = (object) => {
        localStorage.setItem(this.stateName, JSON.stringify({
            tail: getTailNumber(),
            domestic: getDomestic(),
            range: getRange(),
            time: new Date().getTime(),
            data: object
        }));
    }

    getCache = () => {
        let state = localStorage.getItem(this.stateName);
        if (state !== undefined && state !== null) {
            state = JSON.parse(state);
            let time = new Date().getTime() - state.time < 60000 * 60;//1 hour
            if (state.tail === getTailNumber() && state.domestic === getDomestic() && state.range === getRange() && time)
                return state.data;
        }
        return null;
    }

}
